import type { ComponentPropsWithoutRef } from "react"
import Link from "next/link"
import cn from "classnames"

import type { CtaLink as CtaLinkType } from "~/types/cms"
import type { Theme } from "~/types/general"

import s from "./PrimaryButton.module.scss"

type PrimaryButtonProps = {
  cta: CtaLinkType
  className?: string
  theme?: Theme
} & ComponentPropsWithoutRef<"a">

export const PrimaryButton = ({
  cta,
  className = "",
  theme = "light", // this is not used in the default boilerplate style but included in case a design requires it in the future
  ...rest
}: PrimaryButtonProps) => {
  const { label, url } = cta

  return (
    <Link
      href={url}
      className={cn(s.primaryButton, s[theme], className)}
      {...rest}
    >
      {label}
    </Link>
  )
}
